import { Dispatch, SetStateAction } from "react";
import { useSearchParams } from "react-router-dom";

import styles from "./Pagination.module.scss";

interface PaginationProps {
  totalPages: number;
  totalDocs: number;
  itemsPerPage: number;
  setItemsPerPage: Dispatch<SetStateAction<number>>;
  queryParam?: string;
}

const Pagination = ({
  totalDocs,
  totalPages,
  itemsPerPage,
  setItemsPerPage,
  queryParam = "page",
}: PaginationProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = Number(searchParams.get(queryParam)) || 1;

  const setCurrentPage = (page: number) => {
    const params = new URLSearchParams(searchParams);
    params.set(queryParam, String(page));
    setSearchParams(params);
  };

  const startEntry = (currentPage - 1) * itemsPerPage + 1;
  const endEntry = Math.min(currentPage * itemsPerPage, totalDocs);

  return (
    <div className={styles.container}>
      <span className={styles.info}>
        Showing {startEntry} - {endEntry} of {totalDocs} entries
      </span>

      <div className={styles.pagination}>
        <div className={styles.selectWrapper}>
          <label htmlFor="pagination-select" className={styles.selectLabel}>
            Items per page
          </label>

          <div className={styles.selectContainer}>
            <select
              value={itemsPerPage}
              onChange={(e) => setItemsPerPage(Number(e.target.value))}
              name="itemsPerPage"
              id="pagination-select"
              className={styles.select}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>

            <div className={styles.selectArrow}>
              <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
                <path
                  d="M1 1.5L6 6.5L11 1.5"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>

        <span className={styles.selectLabel}>Page: {currentPage}</span>
        <button
          onClick={() => setCurrentPage(Math.max(currentPage - 1, 1))}
          disabled={currentPage === 1}
        >
          Prev
        </button>

        <button
          onClick={() => setCurrentPage(Math.min(currentPage + 1, totalPages))}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
